import * as React from 'react';

import { SortableTh } from 'bundles/admin-shared/components/SortableTh';
import { TableMultiSelectSelectAllCheckbox } from 'bundles/admin-shared/components/TableMultiSelect';
import { Th, Thead, Tr } from 'bundles/admin-shared/components/styledTableComponents';

import _t from 'i18n!nls/staff-management';

import { SORT_KEYS } from '../constants';

const TableHeader = () => {
  return (
    <Thead>
      <Tr>
        <Th aria-label={_t('Row selection')}>
          <TableMultiSelectSelectAllCheckbox />
        </Th>
        {/*
         // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
        <SortableTh sortI18nNoun={_t('name')} sortKey={SORT_KEYS.fullName} label={_t('Name')} />
        {/*
         // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
        <SortableTh sortI18nNoun={_t('email')} sortKey={SORT_KEYS.email} label={_t('Email')} />
        {/*
         // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
        <SortableTh sortI18nNoun={_t('roles')} sortKey={SORT_KEYS.rolesLabel} label={_t('Roles')} />
        <Th scope="col" />
      </Tr>
    </Thead>
  );
};

export default TableHeader;
